var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import $ from '~/helpers/$';
export function Link(_a) {
    var { link } = _a, props = __rest(_a, ["link"]);
    const onClick = React.useCallback((e) => {
        if (link.target.type === 'anchor') {
            e.preventDefault();
            const target = document.getElementById(link.target.value.substring(1));
            if (target) {
                $.scrollTo(target);
            }
        }
    }, [link]);
    return React.createElement("a", Object.assign({ "aria-label": link.ariaLabel || undefined }, props, { href: link.target.value, onClick: onClick }), link.text);
}
